import { defineStore } from 'pinia'
import axios from 'crypto-fetch/axios'

export const useWidgetsTabsStore = defineStore('widgetsTabs', {
  state: () => ({
    widgetsTabs: null
  }),
  actions: {
    async getDetailWidgetsTabs({ eventId, searchType = 1, status }) {
      this.widgetsTabs = null
      const params = { eventId, searchType }
      if (status) {
        params.eventStatus = 0
      }
      const data = await axios.get('/facts-center/query/frontend/tab/list', { params })
      this.widgetsTabs = data
    }
  }
})
